import React from 'react';
import { Zoom } from 'react-reveal';
import { useNavigate } from 'react-router-dom';


const OneToTenCourseCart = ({ tenCourse }) => {
    const { subject, subLogo, _id } = tenCourse;

    //handleSubject
    const navigate = useNavigate();
    const handleSubject = () => {
        navigate(`/lesson/${_id}`)
    }

    return (
        <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg myfont" onClick={handleSubject}>
                    <div className="free-10 d-flex align-items-center">
                        <div className="freeLogo">
                            <img src={subLogo} alt={subLogo} className='img-fluid' style={{ height: '50px' }} />
                        </div>
                        <div className="freeSub">
                            <h4> {subject}</h4>
                        </div>
                    </div>
                </div>
            </Zoom>
        </div>
    );
};

export default OneToTenCourseCart;